import { useEffect, useState } from 'react'
import { fetchRedEnvelopePlayConfig } from '../services/redEnvelopeService'

/**
 * แสดงแท็บซองแดงเมื่อ platform เปิด + master switch + มีโหมด
 */
export function useRedEnvelopeUserEntry(redEnvelopeEnabled?: boolean) {
  const [userEntryVisible, setUserEntryVisible] = useState(false)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    let cancelled = false

    void (async () => {
      if (redEnvelopeEnabled !== true) {
        if (!cancelled) {
          setUserEntryVisible(false)
          setChecked(true)
        }
        return
      }

      try {
        const res = await fetchRedEnvelopePlayConfig()
        if (!cancelled) {
          const visible = res.data?.userEntryVisible === true && (res.data?.modes?.length ?? 0) > 0
          setUserEntryVisible(visible)
          setChecked(true)
        }
      } catch {
        if (!cancelled) {
          setUserEntryVisible(false)
          setChecked(true)
        }
      }
    })()

    return () => {
      cancelled = true
    }
  }, [redEnvelopeEnabled])

  return {
    showRedEnvelopeEntry: redEnvelopeEnabled === true && userEntryVisible,
    checked,
  }
}
